<script>
  let { action, members, types, onSave, onCancel } = $props();

  let edited = $state({ ...action });
  let submitted = $state(false);

  function isValid() {
    return (
      edited.typ !== undefined &&
      edited.typ !== null &&
      edited.idcz !== undefined &&
      edited.idcz !== null &&
      !!edited.data_od &&
      !!edited.uchwala
    );
  }

  function ok() {
    submitted = true;
    if (!isValid()) return;
    if (edited.data_do === "") edited.data_do = null;
    if (edited.kwota === "") edited.kwota = null;
    onSave(edited);
  }
</script>

<div class="modal-header">
  <h4 class="modal-title">{edited.hasOwnProperty("idak") ? "Edycja akcji" : "Utworzenie nowej akcji"}</h4>
</div>
<div class="modal-body">
  <div class="panel panel-default">
      <div class="panel-body">
            <form class="form form-inline" onsubmit={(e) => { e.preventDefault(); ok(); }}>
            <table class="table table-condensed table-hover table-striped">
			<tbody>
			  <tr>
				<td>
				Typ akcji:
				</td>
				<td>
				<select class="form-control input-sm" bind:value={edited.typ}>
				  {#each types as option}<option value={option.idx}>{option.name}</option>{/each}
				</select>
				{#if submitted && (edited.typ === undefined || edited.typ === null)}<small style="color:red">Trzeba wybrać typ</small>{/if}
				</td>
			  </tr>
			  <tr>
				<td>
				Dotyczy osoby:
				</td>
				<td>
				<select class="form-control input-sm" bind:value={edited.idcz}>
				  {#each members as option}<option value={option.idcz}>{option.imie} {option.nazwisko}</option>{/each}
				</select>
				{#if submitted && (edited.idcz === undefined || edited.idcz === null)}<small style="color:red">Trzeba wybrać osobę, której dotyczy akcja</small>{/if}
				</td>
			  </tr>
			  <tr>
				<td>
				Data początkowa:
				</td>
				<td>
				<input type="text" class="form-control input-sm" placeholder="RRRR-MM-DD" bind:value={edited.data_od} size="40">
				{#if submitted && !edited.data_od}<small style="color:red">Trzeba wybrać datę</small>{/if}
				</td>
			  </tr>
			  {#if !(edited.typ == 1 || edited.typ == 2)}
			  <tr>
				<td>
				Data końcowa:
				</td>
				<td>
				<input type="text" class="form-control input-sm" placeholder="RRRR-MM-DD" bind:value={edited.data_do} size="40">
				</td>
			  </tr>
			  {/if}
              {#if edited.typ != 3}
              <tr>
				<td>
				Kwota:
				</td>
				<td>
				<input type="text" class="form-control input-sm" placeholder="Kwota" bind:value={edited.kwota} size="40">
				</td>
			  </tr>
			  {/if}
              <tr>
                <td>
                Numer uchwały Zarządu:
                </td>
                <td>
                <input type="text" class="form-control input-sm" placeholder="Numer uchwały" bind:value={edited.uchwala} size="40">
                {#if submitted && !edited.uchwala}<small style="color:red">Trzeba wpisać numer uchwały Zarządu</small>{/if}
                </td>
              </tr>
			</tbody>
			</table>
            </form>
      </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-success" onclick={ok}>Zapisz</button>
  <button class="btn btn-default" onclick={onCancel}>Anuluj</button>
</div>
